import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteProductMasterApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteProductMaster = createAsyncThunk('deleteProductMaster', async (payload) => {
  return await deleteProductMasterApi(payload);
});

const deleteProductMasterSlice = createSlice({
  name: 'deleteProductMaster', // Unique Name
  initialState,
  reducers: {
    deleteProductMasterReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteProductMaster.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteProductMaster.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteProductMaster.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteProductMasterReset } = deleteProductMasterSlice.actions;

export default deleteProductMasterSlice.reducer;
